import { getRentResouceBatchWallet } from "src/api/tronRentResourceRecords";
import PageConfigProvider from "src/features/PageConfigProvider";
import ViewFilterTable from "./ViewFilterTable";
import { initFields } from "./constants/initFields";
import useGetListParams from "./helpers/useGetListParams";

const TronRentResourceRecords = () => {
  const { getListParams } = useGetListParams();
  return (
    <PageConfigProvider
      translatePrefix="tronRentResourceRecords"
      initFields={initFields}
      getListParams={getListParams}
      getTableDataApiFunc={getRentResouceBatchWallet}
    >
      <ViewFilterTable />
    </PageConfigProvider>
  );
};

export default TronRentResourceRecords;
